/*=========================================================================================
  File Name: moduleDashboard.js
  Description: Dashboard Module
==========================================================================================*/

import state from "./moduleDashboardState.js";
import mutations from "./moduleDashboardMutations.js";
import actions from "./moduleDashboardActions.js";
import getters from "./moduleDashboardGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
